import React from "react";

import "./CookieListHead.scss";
import { useTranslation } from "react-i18next";

const CookieListHead: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="cookie-list-head">
      {[
        t("COOKIE_SETTINGS_COLUMN_NAME"),
        t("COOKIE_SETTINGS_COLUMN_PROVIDER"),
        t("COOKIE_SETTINGS_COLUMN_PURPOSE"),
        t("COOKIE_SETTINGS_COLUMN_TYPE"),
        t("COOKIE_SETTINGS_COLUMN_DURATION")
      ].map((columnName, i) => (
        <div key={`${columnName}-${i}`} className="cookie-list-head__item">
          {columnName}
        </div>
      ))}
    </div>
  );
};

export default CookieListHead;
